import { render } from "./NotFoundLogo.vue?vue&type=template&id=1c15f912"
import script from "./NotFoundLogo.vue?vue&type=script&lang=js"
export * from "./NotFoundLogo.vue?vue&type=script&lang=js"

import "./NotFoundLogo.vue?vue&type=style&index=0&id=1c15f912&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__